export default __webpack_public_path__ + "e733589ba9cfdc80e81f92e1067aa75f.png";